<template>
  <MasterLayout v-if="showHead">
    <router-view/>
  </MasterLayout>
  <router-view v-else/>

</template>
<script>
import { io } from "socket.io-client";
import {mapActions, mapGetters} from "vuex";
import {sleep} from "@/shared/helper";
import MasterLayout from "@/components/MasterLayout";

export default {
  components: {MasterLayout},
  props : ['title'],
  data()
  {
    return{
      socket:null,
      socketRetry:0,
      path:this.$route.path,
    }
  },
  mounted()
  {
    this.connectToSocket();
  },
  methods:{
    async connectToSocket()
    {
      await sleep(500)
      if (!this.userData || !this.userData.token)
        return;

      this.socket = io(process.env.VUE_APP_API_URL.replace('http','ws'), {
        reconnectionDelayMax: 10000,
        extraHeaders: {
          authorization: 'bearer ' + this.userData.token
        }
      });

      this.socket.io.on('open',()=>{
        console.log('socket opened2');
        this.setSocket(this.socket);
        this.joinRooms();
      });

      // this.socket.io.on('close',()=>{
      //   if (this.socketRetry>=8)
      //     return;
      //   this.socketRetry++;
      //   this.connectToSocket();
      // })
    },
    async joinRooms()
    {
      this.socket.emit('join');
    },
    ...mapActions('socket',{
      setSocket:'setSocket'
    })
  },
  computed:{
    ...mapGetters('auth',{
      userData:'getAuthData'
    }),
    ...mapGetters('app',{
      pageTitle:'pageTitle',
      showHead:'showHead'
    }),
  },
  beforeMount()
  {
    document.body.classList.add('dark-sidenav');
  }
}
</script>

<style lang="css">
@import '../public/css/bootstrap.min.css';
@import "../public/css/fontawesome.css";
@import "../public/css/metisMenu.min.css";
@import '~vue-select/dist/vue-select.css';
@import "../public/css/app-rtl.min.css";
@import "../public/css/style.css";
@import "assets/css/animate.min.css";
#app {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  width: 100%;
  font-family:iransans-light
}
html,body
{
  direction: rtl;
  text-align: right;
  background: #f5f8fb!important;
  font-family:iransans-light
}
.page-wrapper .page-content
{
  padding: 0;
  padding-bottom:60px;
}

@media only screen and (max-width: 600px) {
  .container-fluid
  {
    padding-left: 5px;
    padding-right: 5px;
  }
}

</style>
